import React__default from 'react';
import { PostFixContainer } from './postfix.styles.js';
import { CellSuffix } from '../cell-suffix/cell-suffix.js';

var Postfix = function Postfix(props) {
  var postfix = props.postfix,
      size = props.size,
      suffix = props.suffix;

  if (postfix) {
    return /*#__PURE__*/React__default.createElement(PostFixContainer, {
      size: size
    }, suffix ? /*#__PURE__*/React__default.createElement(CellSuffix, null, suffix) : null, postfix);
  }

  return null;
};

export { Postfix };
